import React, { PureComponent } from 'react';

import CKEditorField, {
  CkEditorBaseConfig,
} from '../CKEditorField/CKEditorField';
import { connect, MapStateToProps } from 'react-redux';
import { RootState } from '../../store/store';
import { getAccessToken } from '../../api/Utils';
import i18n from 'i18next';
import Button from '../Button/Button';
import { IQuestionsView, ISurveyView } from '../../store/survey/surveyTypes';
import { languageDirection } from '../../i18n';
import styled from 'styled-components';
import LocalIcon from 'ui/LocalIcon';
import { black, red } from 'utils/style/colors';
import { truncate } from 'lodash';

const ButtonContainer = styled.div`
  padding-top: 0.75rem !important;

  & > button {
    font-size: 0.8rem !important;
    padding: 0.5rem 0.75rem !important;
    border-radius: 0.75rem !important;
  }
`;

interface IOwnProps {
  id: string | number;
  text?: string;
  onChangeInput: (value: string, name: string) => void;
  disabled?: boolean;
  open: boolean;
  handler?: () => void;
  question: IQuestionsView;
  survey?: ISurveyView;
}

interface IStateToProps {
  token: string;
}
type IDescriptionInput = IStateToProps & IOwnProps;

export const getDescriptionInputStatus = (
  survey: ISurveyView,
  question: IQuestionsView
) => {
  const hasQuestionDescriptionStatus = question.fields?.find(
    (field) => field.name === 'conf_addDescriptionButton'
  );

  if (hasQuestionDescriptionStatus)
    return hasQuestionDescriptionStatus.value === 'true';

  const hasSurveyDescriptionStatus = survey.fields?.find(
    (field) => field.name === 'conf_addDescriptionButton'
  );

  if (hasSurveyDescriptionStatus)
    return hasSurveyDescriptionStatus.value === 'true';
  else return truncate;
};

class DescriptionInput extends PureComponent<IDescriptionInput> {
  nameInput: React.RefObject<HTMLTextAreaElement> =
    React.createRef<HTMLTextAreaElement>();

  // onChangeDescription = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  //   this.props.onChangeInput(e.target.value, 'description');
  // };

  componentDidMount() {
    if (!this.props.text && this.nameInput.current) {
      this.nameInput.current.focus();
    }
  }

  render() {
    const { id, text, disabled, token, handler, open, survey, question } =
      this.props;
    const customTitle =
      question.fields?.find((it) => it.name === 'conf_addDescriptionTitle')
        ?.value ||
      survey?.fields?.find((it) => it.name === 'conf_addDescriptionTitle')
        ?.value;
    return handler && !open ? (
      <ButtonContainer>
        <Button color="primary-outline" onClick={handler}>
          {customTitle ||
            (i18n.t('addDescription', { ns: 'survey' }) as string)}
        </Button>
      </ButtonContainer>
    ) : (
      <div>
        <div className="flex items-center">
          <LocalIcon
            isLink={true}
            onClick={() => handler?.()}
            color={red}
            iconName="x.svg"
            type="sm"
          />
          <label style={{ color: black }}>
            {customTitle || (i18n.t('description', { ns: 'survey' }) as string)}
          </label>
        </div>
        <CKEditorField
          id={'ckeditor-desc-' + id}
          disabled={disabled}
          style={{}}
          // editor={ClassicEditor}
          data={text || ''}
          onChange={(_: any, editor: any) => {
            const data = editor.getData();
            this.props.onChangeInput(data, 'description');
          }}
          dir={languageDirection()}
          config={CkEditorBaseConfig(token)}
          // wrapperClassName={'ckeditorMinHeight200'}
        />
      </div>
    );
    /*<Textarea
        id="textarea"
        name={`${id}-description`}
        value={text || ''}
        style={{ resize: 'none' }}
        label={i18n.t('description', { ns: 'survey' })}
        onChange={this.onChangeDescription}
        forwardRef={this.nameInput}
      />*/
  }
}

// export default React.memo(DescriptionInput);

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state
) => {
  const token = getAccessToken(state)!;
  return { token };
};
export default React.memo(
  connect(mapStateToProps)(DescriptionInput)
) as unknown as React.ComponentType<IOwnProps>;
